import {RequiredConnectedProps} from "./types.ts";
import {Multiselect, SelectOption} from "@rio-cloud/rio-uikit";
import {useController, useFormContext} from "react-hook-form";
import {useGeneratedId} from "./utils.tsx";
import {useHasViolation} from "./useHasViolation.ts";
import {FormGroup} from "./FormGroup.tsx";
import {ValidationViolation} from "./ValidationViolation.tsx";

type ConnectedMultiSelectProps = RequiredConnectedProps & {
    options: SelectOption[];
    placeholder?: string;
}

export const ConnectedMultiSelect = ({name, placeholder, options, label}: ConnectedMultiSelectProps) => {

    const {control} = useFormContext()
    const id = useGeneratedId(name)
    const {hasViolation, violations} = useHasViolation(name)
    const {field} = useController({name, control})

    return <FormGroup hasViolation={hasViolation}>
        <label htmlFor={id}>{label}</label>
        <Multiselect
            id={id}
            placeholder={placeholder}
            options={options}
            multiline
            useFilter
            value={field.value}
            onChange={selectOptions => field.onChange(selectOptions)}
            />
        <ValidationViolation violations={violations} />
    </FormGroup>
}